import type * as Fetcher from '@repo/api-codegen';
import { apiFetch } from '@repo/api-codegen';
import { SortValue } from '@repo/common/components/Filter/types';
import type { EntityType } from '@repo/common/enums/entityType';
import { useQuery } from '@tanstack/react-query';

export type SearchResult = {
	id: string;
	title: string;
	title_cased?: string;
	parent?: string;
	entity_type: EntityType;
	native_type?: string;
	integration: string;
	integration_type?: string;
	search_metadata: Record<string, string>;
	internal_users: string[];
	external_users: string[];
};

export type SearchResponse = {
	results: SearchResult[];
};

type SearchError = Fetcher.ErrorWrapper<undefined>;

type SearchQueryParams = {
	search_term: string;
	sort: string;
	page: number;
};

function useSearch({ searchTerm }: { searchTerm: string }) {
	return useQuery<SearchResult[], SearchError, SearchResult[]>({
		queryKey: ['lineage-flow', 'search', searchTerm],
		queryFn: async () => {
			const queryParams = {
				search_term: searchTerm,
				sort: JSON.stringify({
					field: SortValue.RELEVANCE.toString(),
					order: 'desc',
				}),
				page: 1,
			};
			const response = await apiFetch<
				SearchResponse,
				SearchError,
				undefined,
				{},
				SearchQueryParams,
				{}
			>({
				url: '/search/',
				method: 'get',
				queryParams,
			});

			return response.results;
		},
	});
}

export default useSearch;
